export enum EmailMessageState {
  Draft,
  Sent,
}
